import { Link } from 'react-router-dom';
import { Calendar, MapPin, Sparkles } from 'lucide-react';
import SEO from '../../components/SEO';

export default function MoedOsHerDe() {
  const messePunkter = [
    'Nehmen Sie an unserem Gewinnspiel teil und gewinnen Sie einen Danshaker für 14 Tage kostenlos',
    'Erleben Sie den Danshaker ganz aus der Nähe',
    'Sehen Sie sich das umfangreiche Zubehörsortiment an',
    'Sehen Sie live, wie schnell und mühelos der Danshaker trennt',
    'Tauschen Sie sich persönlich mit uns über Ihren Stallbedarf aus',
    'Buchen Sie direkt vor Ort eine kostenlose Vorführung in Ihrem eigenen Stall',
    'Stellen Sie all Ihre individuellen Fragen'
  ];

  const eventsList = [
    {
      title: 'Hest og Rytter 2027',
      dates: '11. – 14. März 2027',
      locationName: 'Messecenter Herning, Dänemark',
      locationDetail: 'Stand F5268',
      badge: '11. - 14. Mär 2027',
      description: 'Besuchen Sie uns bei Hest og Rytter im Messecenter Herning. Wir heißen Sie herzlich willkommen und präsentieren Ihnen unsere Entmistungsmaschine und Zubehör im Live-Einsatz.'
    }
  ];

  const eventSchemas = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Event',
        name: 'Hest og Rytter 2027 - Danshaker treffen',
        startDate: '2027-03-11',
        endDate: '2027-03-14',
        eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
        eventStatus: 'https://schema.org/EventScheduled',
        location: {
          '@type': 'Place',
          name: 'Messecenter Herning (Stand F5268)',
          address: {
            '@type': 'PostalAddress',
            addressLocality: 'Herning',
            addressCountry: 'DK',
          },
        },
        description: 'Treffen Sie Danshaker bei Hest og Rytter 2027 im Messecenter Herning auf Stand F5268.',
      }
    ]
  };

  return (
    <div className="relative min-h-screen bg-slate-50 text-slate-900 antialiased">
      <SEO
        title="Messen & Termine - Hest og Rytter 2027"
        description="Besuchen Sie Danshaker auf Pferdemessen und Events wie Hest og Rytter im Messecenter Herning (11.–14. März 2027, Stand F5268). Erleben Sie die Maschine live und lassen Sie sich beraten."
        path="/de/uns-treffen"
        schema={eventSchemas}
        lang="de"
      />

      {/* Background gradients */}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(14,103,162,0.05),transparent_60%)]" />

      {/* Header Section */}
      <section className="mx-auto max-w-7xl px-4 pt-16 pb-12 md:px-8 md:pt-24">
        <div className="text-center max-w-3xl mx-auto space-y-4">
          <div className="inline-flex items-center gap-2 rounded-full bg-[#0E67A2]/10 px-4 py-1.5 text-xs font-bold text-[#0E67A2]">
            <Sparkles className="h-3.5 w-3.5" aria-hidden="true" />
            <span>Messen & Veranstaltungen</span>
          </div>
          <h1 className="text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">
            Treffen Sie uns vor Ort
          </h1>
          <p className="text-lg text-slate-600 leading-relaxed">
            Wir nehmen regelmäßig an Messen und Reitsportveranstaltungen teil. Kommen Sie vorbei und erleben Sie den Danshaker hautnah!
          </p>
        </div>
      </section>

      {/* Events List */}
      <section className="mx-auto max-w-7xl px-4 py-8 md:px-8">
        <div className="space-y-8 max-w-4xl mx-auto">
          {eventsList.map((evt, idx) => (
            <div
              key={idx}
              className="rounded-3xl border border-slate-200 bg-white p-8 md:p-10 shadow-xl space-y-6 relative overflow-hidden"
            >
              <div className="flex flex-wrap items-center justify-between gap-4 border-b border-slate-100 pb-6">
                <div>
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="inline-flex items-center gap-1.5 rounded-full bg-[#0E67A2] px-3.5 py-1 text-xs font-bold text-white shadow-xs">
                      <Calendar className="h-3.5 w-3.5" />
                      {evt.badge}
                    </span>
                    <span className="inline-flex items-center rounded-full bg-emerald-100 px-3.5 py-1 text-xs font-bold text-emerald-800">
                      {evt.extraBadge}
                    </span>
                  </div>
                  <h2 className="text-2xl md:text-3xl font-extrabold text-slate-900">
                    {evt.title}
                  </h2>
                </div>
              </div>

              <div className="flex flex-wrap items-center gap-6 text-sm text-slate-700 font-semibold">
                <div className="flex items-center gap-2">
                  <MapPin className="h-4 w-4 text-[#0E67A2]" />
                  <span>{evt.locationName}</span>
                </div>
                <div className="flex items-center gap-2 text-[#0E67A2]">
                  <span className="rounded-md bg-[#0E67A2]/10 px-2 py-0.5 font-bold">
                    {evt.locationDetail}
                  </span>
                </div>
              </div>

              <p className="text-slate-600 leading-relaxed font-medium">
                {evt.description}
              </p>

              <div className="rounded-2xl bg-slate-50 border border-slate-200 p-6 space-y-4">
                <h3 className="text-base font-bold text-slate-900">
                  Auf unserem Stand können Sie unter anderem:
                </h3>
                <ul className="grid sm:grid-cols-2 gap-3 text-sm text-slate-700">
                  {messePunkter.map((pt, i) => (
                    <li key={i} className="flex items-start gap-2.5">
                      <span className="text-[#0E67A2] font-bold text-base mt-0.5">✓</span>
                      <span className="font-medium">{pt}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="pt-2 flex flex-wrap gap-4">
                <Link
                  to="/de/kostenlose-demo"
                  className="rounded-xl bg-[#0E67A2] px-6 py-3 font-bold text-white transition hover:bg-[#0E67A2]/90 shadow-md"
                >
                  Kostenlose Vorführung buchen
                </Link>
                <Link
                  to="/de/kontakt"
                  className="rounded-xl border border-slate-300 bg-white px-6 py-3 font-bold text-slate-800 transition hover:bg-slate-100"
                >
                  Fragen stellen
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
